import React from "react";
import { SelectInput } from "~/components/ui/core/BetterSelectInput";
import { Icon } from "~/components/ui/core/Icon";
import { useI18n } from "~/lib/i18n/useI18n";

type Event = {
  target: {
    value: boolean;
  };
};

type Option = {
  label: string;
  value: boolean;
};

type Props = {
  displayEmployees: boolean;
  onChange: (event: Event) => void;
};

const handleChange = (onChange: Props["onChange"]) => (event: { target: { value: Option[] } }) => {
  const [selectedOption] = event.target.value;
  if (!selectedOption) {
    return;
  }

  onChange({
    target: {
      value: selectedOption.value,
    },
  });
};

export const SelectDisplayEmployees: React.FC<Props> = ({ displayEmployees, onChange }) => {
  const { t } = useI18n();

  const options: Option[] = [
    { label: t("components.ui.select-display-employees.show-employees"), value: true },
    { label: t("components.ui.select-display-employees.hide-employees"), value: false },
  ];

  const value = options.filter((option) => option.value === displayEmployees);

  return (
    <SelectInput
      groups={[
        {
          label: "",
          options,
        },
      ]}
      hideGroupLabels={true}
      formatLabel={(value) => (
        <div className="group ml-6 mt-1 flex items-center">
          <span className="flex items-center text-sm">
            <Icon
              className="transform text-gray-500 transition group-hover:scale-110 group-hover:text-primary-600"
              name="account-group"
            />
            <span className="ml-1.5">{value[0]?.label}</span>
          </span>
          <Icon className="text-gray-500" name="menu-down" />
        </div>
      )}
      formatOption={(option) => (option ? option.label : "-")}
      placeholder="Toggle Employee Display"
      value={value}
      optionToId={(option) => option?.label ?? ""}
      onChange={handleChange(onChange)}
    />
  );
};
